<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['network:natMonitor:delete']"
            @click="tableDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          v-hasPermission="['network:natMonitor:detail']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="tableDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ elasticResourceName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeElasticResource()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDateVue = {};
export default {
  name: "TableNat",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      tableDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      elasticResourceName: "",
      columns: [
        {
          title: this.$t("alarms.instance.accountType"),
          fixed: "left",
          width: 150,
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          width: 150,
          key: "accountName"
        },
        {
          title: this.$t("alarms.network.nat.region"),
          width: 150,
          key: "region"
        },
        {
          title: this.$t("alarms.network.nat.name"),
          width: 150,
          key: "name"
        },
        {
          title: this.$t("alarms.network.nat.natGatewayId"),
          width: 150,
          key: "natGatewayId"
        },
        {
          title: this.$t("alarms.network.nat.state"),
          width: 150,
          key: "state"
        },
        {
          title: this.$t("alarms.network.nat.publicIp"),
          width: 150,
          key: "publicIp"
        },
        {
          title: this.$t("alarms.network.nat.privateIp"),
          width: 150,
          key: "privateIp"
        },
        {
          title: this.$t("alarms.network.nat.vpcId"),
          width: 150,
          key: "vpcId"
        },
        {
          title: this.$t("alarms.network.nat.createTime"),
          width: 150,
          key: "createTime"
        },
        {
          title: this.$t("alarms.instance.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("common.operation"),
          fixed: "right",
          width: 150,
          slot: "delete"
        }
      ],
      tableDate: []
    };
  },
  beforeCreate: function() {
    tableDateVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableDateVue.companyId = val;
    });
    eventBus.$on("accountType", function(val) {
      tableDateVue.accountType = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDateVue.accountName = val;
    });
    eventBus.$on("publicIp", function(val) {
      tableDateVue.publicIp = val;
    });
    eventBus.$on("natGatewayId", function(val) {
      tableDateVue.natGatewayId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDateVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      //列表分页
      this.$api.nat
        .pageNat({
          pageNum: this.current,
          pageSize: this.pageSize,
          monitorModule: 39,
          accountName: tableDateVue.accountName,
          accountType: tableDateVue.accountType,
          companyId: tableDateVue.companyId,
          name: tableDateVue.name,
          natGatewayId: tableDateVue.natGatewayId
        })
        .then(res => {
          this.tableDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(err => {});
    },
    changePage: function(current) {
      this.current = current;
      tableDateVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDateVue.getData();
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.elasticResourceName = this.tableDate[index].accountName;
    },
    removeElasticResource: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.nat.deleteNat("id", this.tableDate[lineIndex].id).then(res => {
        this.modal_loading = true;
        setTimeout(() => {
          // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
          //21条  3页  2*10+1时删除
          if (
            lineIndex == 0 &&
            (this.current - 1) * this.pageSize + 1 == this.dataTotal
          ) {
            this.current = this.current - 1;
          }
          this.dataTotal = this.dataTotal - 1;
          tableDateVue.getData();
          this.isDisable = false;
          this.modal_loading = false;
          this.tableDelmodal = false;
          this.$Message.success("删除成功");
        }, 1000);
      });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/network/natDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          name: row.clusterIdentifier,
          region: row.region,
          accountTypeName: row.accountTypeName,
          // instanceId: row.instanceId,
          natGatewayId: row.natGatewayId,
          accountName: row.accountName,
          publicIp: row.publicIp,
          allocationId: row.allocationId,
          monitorModule: 39
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/nat/TableNat.vue